import * as Sentry from "@sentry/browser"
import { EnvVar, envVar } from "./env"

export const setupSentry = () => {
  const sentryOptions: Sentry.BrowserOptions = {
    enabled: envVar(EnvVar.SENTRY_ENABLED) === true,
    dsn: envVar(EnvVar.SENTRY_DSN)?.toString() || "",
    integrations: [Sentry.browserTracingIntegration()],
    environment: envVar(EnvVar.SENTRY_ENVIRONMENT)?.toString() || "",
    tracesSampleRate: parseFloat(
      envVar(EnvVar.SENTRY_SAMPLE_RATE)?.toString() || "0.0"
    ),
    ignoreErrors: [
      "AbortError",
      "Aborted request",
      "ResizeObserver loop completed with undelivered notifications",
      "ReferenceError: Can't find variable: pktAnnotationHighlighter",
      "ReferenceError: Can't find variable: article",
      "Non-Error promise rejection captured with value",
      // Is a benign 'error', see https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
      "ResizeObserver loop limit exceeded",
      "Error response received for message <get-frame-manager-configuration>",
    ],
    denyUrls: [
      new RegExp("chrome-extension://.*"),
      new RegExp("moz-extension://.*"),
    ],
  }
  Sentry.init(sentryOptions)
  Sentry.setTag("service", envVar(EnvVar.SENTRY_SERVICE)?.toString() || "")
}
